;(function () {
	const initCollapsibleContent = () => {
		$('.collapsible-content__toggle')
			.off('click')
			.on('click', function () {
				const parent = $(this).parent()
				const answer = $(this).next('.collapsible-content__answer')

				if (!parent.hasClass('active')) {
					parent
						.siblings('.collapsible-content__item.active')
						.removeClass('active')
						.find('.collapsible-content__answer')
						.stop()
						.slideUp(300, function () {
							$(this).css('display', 'none')
						})

					parent.addClass('active')

					answer.stop().slideDown(300, function () {
						$(this).css('display', 'block')
					})
				} else {
					parent.removeClass('active')

					answer.stop().slideUp(300, function () {
						$(this).css('display', 'none')
					})
				}
			})
	}

	const handleResize = () => {
		$('.collapsible-content__answer').removeAttr('style')

		$('.collapsible-content__item.active .collapsible-content__answer').css(
			'display',
			'block'
		)
	}

	const openAccordionFromHash = () => {
		const hash = window.location.hash

		if (!hash) return

		const answer = $(hash)

		if (!answer.length) return

		const item = answer.closest('.collapsible-content__item')

		if (!item.length) return

		$('.collapsible-content__item.active')
			.not(item)
			.removeClass('active')
			.find('.collapsible-content__answer')
			.stop()
			.slideUp(300, function () {
				$(this).css('display', 'none')
			})

		item.addClass('active')

		answer.stop().slideDown(300, function () {
			$(this).css('display', 'block')
		})

		setTimeout(() => {
			$('html, body').animate(
				{
					scrollTop: item.offset().top - 120
				},
				300
			)
		}, 300)
	}

	window.addEventListener('resize', handleResize)
	window.addEventListener('hashchange', openAccordionFromHash)

	document.addEventListener('shopify:section:load', function () {
		initCollapsibleContent()
		handleResize()
		openAccordionFromHash()
	})

	initCollapsibleContent()
	handleResize()
	openAccordionFromHash()
})()
``